export default class SUKUSearchresults extends HTMLElement {
  static get observedAttributes() {
    return ['results', 'active']
  }

  constructor() {
    super()

    this.className = 'w-full flex bg-white border-b border-black hidden mobile:flex-wrap'
    this.listClass = ''
    this.listItemClass = 'text-[14px] leading-tight !mb-0'
    this.linkClass = 'text-black !text-left hover:underline'

    this.collections = this.querySelector('[data-collections]')
    this.collectionsList = this.querySelector('[data-collections-list]')
    this.pages = this.querySelector('[data-pages]')
    this.pagesList = this.querySelector('[data-pages-list]')
    this.articles = this.querySelector('[data-articles]')
    this.articlesList = this.querySelector('[data-articles-list]')

    document.body.addEventListener('search-results', this.handleSearchResults)
  }

  handleSearchResults = (evt) => {
    const { collections, pages, articles, products } = evt.detail.results

    const hasResults = collections?.length > 0 || pages?.length > 0 || articles?.length > 0 || products?.length > 0

    this.setAttribute('active', hasResults)

    if (collections?.length > 0) {
      this.collections.classList.remove('hidden')

      this.collectionsList.innerHTML = collections.map((collection) => {
        return `<li class="${this.listItemClass}">
            <a href="${collection.url}" class="${this.linkClass}">
              ${collection.title}
            </a>
          </li>`
      }).join('')
    } else {
      this.collections.classList.add('hidden')
    }

    if (pages?.length > 0) {
      this.pages.classList.remove('hidden')
      this.pagesList.innerHTML = pages.map((page) => {
        return `<li class="${this.listItemClass}">
            <a href="${page.url}" class="${this.linkClass}">
              ${page.title}
            </a>
          </li>`
      }).join('')
    } else {
      this.pages.classList.add('hidden')
    }

    if (articles?.length > 0) {
      this.articles.classList.remove('hidden')
      this.articlesList.innerHTML = articles.map((article) => {
        return `<li class="${this.listItemClass}">
            <a href="${article.url}" class="${this.linkClass}">
              ${article.title}
            </a>
          </li>`
      }).join('')
    } else {
      this.articles.classList.add('hidden')
    }
  }

  attributeChangedCallback(name, previous, current) {
    if (previous === current) {
      return
    }

    switch (name) {
      case 'results':
        this.results = current
        break
      case 'active':
        this.active = current === 'true' ? true : false

        // show/hide the search results
        if (this.active) {
          this.classList.remove('hidden')
        } else {
          this.classList.add('hidden')
        }
        break
    }
  }
}

customElements.define('suku-search-results', SUKUSearchresults)
